/* eslint-disable */
export const signInHeaderStyle = {
  flexWrap: 'wrap' as any,
  flexDirection: 'column' as any,
  textAlign: 'center' as any,
};

export const signInTypographyStyle = {
  textAlign: 'center' as any,
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const forgotLabelStyle = { marginTop: '32px' };
